import {createSlice} from '@reduxjs/toolkit';
import {retrieveMyBusinessProfile} from "../../api/myprofile/myBusinessProfile";

export const businessProfileSlice = createSlice({
    name: 'businessProfile/retrieve',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveMyBusinessProfile.pending, (state, action) => {
                state.request = true;
            })
            .addCase(retrieveMyBusinessProfile.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(retrieveMyBusinessProfile.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const { cancelError, showError, showSuccess } = businessProfileSlice.actions

export default businessProfileSlice.reducer;